<template>
  <div class="web_map">
    <el-button type="primary" size="small" class="el-icon-download download" @click="download">下载</el-button>
  </div>
</template>
<script>
import { getManagerList, deleteAdmin } from "@/api/auth";

export default {
  data() {
    return {
      activeIndex: "1",
      remark: "",
      showBtns: false,
      dialogTitle: "",
      dialogType: "",
      list: [],
      dialogVisible: false,
      roleList: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: false,
    };
  },

  async mounted() {},
  methods: {
    download() {
      window.open("https://cloud-pc-api-yc-2022.gymooit.cn/sitemap.xml", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.web_map {
  display: flex;
  align-items: center;
  .download {
    margin-right: 30px;
  }
}
</style>
